import React, { useState, useEffect } from 'react'
import TopBar from '../../Components/Cashier/TopBar'
import SideBar from '../../Components/Cashier/SideBar'
import Main from '../../Components/Cashier/Main'
import { getUserInfoSync } from '../../config/api'

const CashierDashboard = () => {
  const [sidebarToggle, setSidebarToggle] = useState(false)
  const userInfo = getUserInfoSync()
  const isFirstLogin = userInfo?.first_login === true
  
  // Initialize activeScreen from localStorage or default to 'new-sale'
  const getInitialScreen = () => {
    if (isFirstLogin) return 'profile'
    const savedScreen = localStorage.getItem('cashier_activeScreen')
    return savedScreen || 'new-sale'
  }
  
  const [activeScreen, setActiveScreen] = useState(getInitialScreen)

  const handleSidebarToggle = () => {
    setSidebarToggle(!sidebarToggle)
  }

  useEffect(() => {
    // Toggle the class on body element based on sidebarToggle state
    if (sidebarToggle) {
      document.body.classList.add('toggle-sidebar')
    } else {
      document.body.classList.remove('toggle-sidebar')
    }
  }, [sidebarToggle])

  // Force profile screen if first login
  useEffect(() => {
    if (isFirstLogin && activeScreen !== 'profile') {
      setActiveScreen('profile')
    }
  }, [isFirstLogin, activeScreen])

  // Save activeScreen to localStorage whenever it changes
  useEffect(() => {
    if (!isFirstLogin && activeScreen) {
      localStorage.setItem('cashier_activeScreen', activeScreen)
    }
  }, [activeScreen, isFirstLogin])

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    // Ensure Bootstrap collapse is initialized
    const initBootstrap = () => {
      if (window.bootstrap && window.bootstrap.Collapse) {
        document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(element => {
          new window.bootstrap.Collapse(element, { toggle: false })
        })
      }
    }
    
    // Wait for Bootstrap to load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBootstrap)
    } else {
      initBootstrap()
    }
  }, [activeScreen])

  return (
    <>
      <TopBar onToggleSidebar={handleSidebarToggle} setActiveScreen={setActiveScreen}/>
      <SideBar activeScreen={activeScreen} setActiveScreen={setActiveScreen} isFirstLogin={isFirstLogin}/>
      <Main
        activeScreen={activeScreen}
        isFirstLogin={isFirstLogin}
        onNavigate={setActiveScreen}
      />
    </>
  )
}

export default CashierDashboard